import { sendGet } from "@torqit/crew-2ls";
import { CfiFoodProgramFormResult } from "../../FoodsProgramForm/CfiFoodProgramTypes";
import { sendFormDataPost } from "../networking/api";
import { apiResponse } from "./Interfaces/response";
import { serialize } from "object-to-formdata";
import { downloadPost } from "../networking/downloadPost";

export async function submitCfiFoodProgramApplication(
  application: CfiFoodProgramFormResult,
  recaptchaToken: string,
  recaptchaAction: string
): Promise<apiResponse> {
  const formData = serialize(
    { application, recaptchaToken, recaptchaAction },
    { indices: true }
  );

  return await sendFormDataPost("/api/cfi-food-program-application", formData);
}

export async function exportFoodProgramEmails(
  fromDate?: string,
  toDate?: string
) {
  const queryParams = new URLSearchParams();
  if (fromDate) {
    queryParams.append("fromDate", fromDate);
  }
  if (toDate) {
    queryParams.append("toDate", toDate);
  }
  await downloadPost(
    `/internal/food-program-email-export?${queryParams.toString()}`,
    {}
  );
}
